import React from 'react';
import PropTypes from 'prop-types';
import { OutlineButton } from '../../@communityshare/ui/Button';
import FormTemplate from '../../dialogs_common/FormTemplate';
import { CheckIcon } from '@heroicons/react/24/outline';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';

Form.propTypes = {
  onClose: PropTypes.func
};

export default function Form(props) {
  const { onClose } = props;

  return (
    <FormTemplate
      icon={(
        <div className="flex justify-center mb-4">
          <CheckIcon className="text-cs-green-500 h-12 w-12" />
        </div>
      )}
      title="Staff access granted."
      // subtitle={(
      //   <span>
      //     This will send an email to {educator.data.firstName} nudging them to complete their project.
      //   </span>
      // )}
      success={true}
      onClose={onClose}
      // alert={alert}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onClose}>
            Close
          </OutlineButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
